import SwitchUI from "../UI/SwitchUi/SwitchUi";
import {useContext, useEffect, useMemo, useState} from "react";
import { Context } from "../../index";

export default function DeliveryTypes() {
	const { delivery } = useContext(Context)

	const fittingDelivery = useMemo(() => {
		
		if (delivery && delivery.allMethods && delivery.allMethods.courier) {
			const findDel = delivery.allMethods.courier.find(
				(del) => del.has_fitting
			);
			if (findDel) {
				return findDel;
			}
		}

		return null;
	}, [delivery])

	const expressDelivery = useMemo(() => {
		if (delivery && delivery.allMethods && delivery.allMethods.courier) {
			const findDel = delivery.allMethods.courier.find(
				(del) => del.is_express
			);
			if (findDel) {
				return findDel;
			}
		}

		return null;
	}, [delivery])

	const [fittingChecked, setFittingChecked] = useState(delivery?.active?.id === fittingDelivery?.id);
	const [expressChecked, setExpressChecked] = useState(delivery?.active?.id === expressDelivery?.id);

	const handleFittingDelivery = (e) => {
		const checked = e.target.checked;
		if (checked) {
			if (!delivery.primeDelivery) {
				delivery.setPrime()
			}
			delivery.setActive(fittingDelivery);
		} else {
			if (delivery?.active?.id === fittingDelivery?.id) {
				delivery.setActive(delivery.primeDelivery);
				delivery.setPrime(true)
			}
		}
		setFittingChecked(checked);
		setExpressChecked(false);
	}

	const handleExpressDelivery = (e) => {
		const checked = e.target.checked;
		if (checked) {
			if (!delivery.primeDelivery) {
				delivery.setPrime()
			}
			delivery.setActive(expressDelivery);
		} else {
			if (delivery?.active?.id === expressDelivery?.id) {
				delivery.setActive(delivery.primeDelivery);
				delivery.setPrime(true)
			}
		}
		setFittingChecked(false);
		setExpressChecked(checked);
	}

	useEffect(() => {
		delivery.setFitting(fittingChecked)
		delivery.setExpress(expressChecked)

	}, [fittingChecked, expressChecked]);


	return <div className='delivery-types'>
		{fittingDelivery && (
			<div className="delivery-types__item">
				<svg className="delivery-types__item-icon" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
					<path fillRule="evenodd" clipRule="evenodd" d="M10.0556 4.05546C10.5714 3.53973 11.2708 3.25 12.0002 3.25C12.7295 3.25 13.429 3.53973 13.9447 4.05546C14.4605 4.57118 14.7502 5.27065 14.7502 6C14.7502 6.41421 14.4144 6.75 14.0002 6.75C13.586 6.75 13.2502 6.41421 13.2502 6C13.2502 5.66848 13.1185 5.35054 12.8841 5.11612C12.6497 4.8817 12.3317 4.75 12.0002 4.75C11.6687 4.75 11.3507 4.8817 11.1163 5.11612C10.8819 5.35054 10.7502 5.66848 10.7502 6C10.7502 7.4223 11.3023 8.5295 12.4325 9.38666L20.3273 13.7723C20.7562 14.0105 21.1136 14.3592 21.3624 14.782C21.6112 15.2048 21.7423 15.6864 21.7422 16.177V17C21.7422 17.7293 21.4525 18.4288 20.9367 18.9445C20.421 19.4603 19.7215 19.75 18.9922 19.75H4.99219C4.26284 19.75 3.56337 19.4603 3.04764 18.9445C2.53192 18.4288 2.24219 17.7293 2.24219 17L2.24219 16.1772C2.24209 15.6866 2.37322 15.2048 2.62197 14.782C2.87076 14.3591 3.22814 14.0105 3.65706 13.7723L10.7146 9.85178C9.74611 8.81112 9.25019 7.5164 9.25019 6C9.25019 5.27065 9.53992 4.57118 10.0556 4.05546ZM11.9922 10.858L4.3854 15.0836C4.19044 15.1919 4.0279 15.3504 3.91482 15.5426C3.80173 15.7348 3.74213 15.9538 3.74219 16.1768V17C3.74219 17.3315 3.87388 17.6495 4.1083 17.8839C4.34272 18.1183 4.66067 18.25 4.99219 18.25H18.9922C19.3237 18.25 19.6416 18.1183 19.8761 17.8839C20.1105 17.6495 20.2422 17.3315 20.2422 17V16.177C20.2422 15.954 20.1826 15.7348 20.0696 15.5426C19.9565 15.3504 19.794 15.1919 19.5991 15.0837L11.9922 10.858Z" fill="#1B1B1B"/>
				</svg>

				<div className="delivery-types__info">
					<span className="delivery-types__info-title">С примеркой</span>
					<span className="delivery-types__info-desc">оплата картой или наличными курьеру после примерки</span>
				</div>

				<SwitchUI checked={fittingChecked} onChange={handleFittingDelivery}/>
			</div>
		)}
		{expressDelivery && (
			<div className="delivery-types__item _grey">
				<svg className="delivery-types__item-icon" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
					<path d="M3.75 13.5L14.25 2.25L12 10.5H20.25L9.75 21.75L12 13.5H3.75Z" stroke="#1B1B1B" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
				</svg>

				<div className="delivery-types__info">
					<span className="delivery-types__info-title">Экспресс-доставка</span>
					<span className="delivery-types__info-data">за 3 часа / +800 ₽</span>
					<span className="delivery-types__info-desc">100% предоплата, без примерки</span>
				</div>

				<SwitchUI checked={expressChecked} onChange={handleExpressDelivery}/>
			</div>
		)}
	</div>
}
